'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import { useFormikContext } from 'formik'

// lib
import Alert, { AlertProps } from '../alert'

/* -----------------------------------------------------------------------------
 * StatusMessage
 * -------------------------------------------------------------------------- */

const DEFAULT_MSG = 'We encountered an unknown error, please try again.'

export type StatusMessageProps = AlertProps & {
  children?: (type: string | undefined, msg: string | undefined) => JSX.Element
  getStatusMsg?: (type: string | undefined, msg: string | undefined) => string
  forcedErrorMsg?: string
}

const StatusMessage = ({
  children,
  getStatusMsg,
  forcedErrorMsg,
  ...props
}: StatusMessageProps) => {
  const { submitCount, status } = useFormikContext()
  const { msg, type } = status || { msg: undefined, type: undefined }
  const statusMsg = getStatusMsg ? getStatusMsg(msg, type) : msg

  if (children) {
    return children(type, statusMsg)
  }

  return (submitCount && type === 'error') || forcedErrorMsg ? (
    <Alert my='08' textAlign='center' type='error' {...props}>
      {forcedErrorMsg || statusMsg || DEFAULT_MSG}
    </Alert>
  ) : null
}

export default StatusMessage
